// import Cookies from 'js-cookie'
// import store from '/src/store'
// import DeviceDetector from '@/plugins/device-detector'

export const beforeEach = (to, from, next) => {
  // console.log('to.name', to.name, to.meta)
  if (to.name === 'SuccessPage') {
    to.meta.headerTitle = to.params.type === 'order' ? 'Оформление заказа' : 'Бронирование столика'
  }
  next()
}



// WEBPACK FOOTER //
// ./src/router/functions/beforeEach.js